import { generatePath, Link } from 'react-router';

import { Badge } from '@/components/common';

import { IRoleAssignmentDetailsCard } from '@/features/role-assignments/interfaces';
import { getRoleStatusLabel, getRoleStatusVariant } from '@/features/role-assignments/utils';
import { AppRoutes } from '@/constants';

const RoleAssignmentDetailsCard = ({ roleAssignmentDetails }: IRoleAssignmentDetailsCard) => {
  return (
    <div className="rounded-softer border border-neutral-n4 bg-neutral-white">
      <div className="text-sm flex flex-col gap-y-base-plus p-m">
        {/* Profile ID */}
        <div className="flex gap-x-xs">
          <div className="font-semibold text-brand-primary-darkest w-[120px] sm:w-[250px]">
            Face Profile ID:
          </div>
          <Link
            className="font-medium text-brand-primary-base underline cursor-pointer flex-1 break-all"
            to={generatePath(AppRoutes.FACE_ID_PROFILE_DETAILS, {
              id: roleAssignmentDetails.profileId,
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            {roleAssignmentDetails.profileId}
          </Link>
        </div>

        {/* Full Name */}
        <div className="flex gap-x-xs">
          <div className="font-semibold text-brand-primary-darkest w-[120px] sm:w-[250px]">
            Full Name:
          </div>
          <div className="font-medium text-neutral-n8 flex-1 break-all">
            {roleAssignmentDetails.fullName}
          </div>
        </div>

        {/* Employee ID */}
        <div className="flex gap-x-xs">
          <div className="font-semibold text-brand-primary-darkest w-[120px] sm:w-[250px]">
            Employee ID:
          </div>
          <div className="font-medium text-neutral-n8 flex-1 break-all">
            {roleAssignmentDetails.employeeId}
          </div>
        </div>

        {/* Email */}
        <div className="flex gap-x-xs">
          <div className="font-semibold text-brand-primary-darkest w-[120px] sm:w-[250px]">
            Email:
          </div>
          <div className="font-medium text-neutral-n8 flex-1 break-all">
            {roleAssignmentDetails.email}
          </div>
        </div>

        {/* Role */}
        <div className="flex gap-x-xs">
          <div className="font-semibold text-brand-primary-darkest w-[120px] sm:w-[250px]">
            Role:
          </div>
          <div className="font-medium text-neutral-n8 flex-1 break-all">
            {roleAssignmentDetails.roleName}
          </div>
        </div>

        {/* Status */}
        <div className="flex gap-x-xs items-center">
          <div className="font-semibold text-brand-primary-darkest w-[120px] sm:w-[250px]">
            Status:
          </div>
          <Badge
            className="border-none"
            variant={getRoleStatusVariant(roleAssignmentDetails.status)}
          >
            {getRoleStatusLabel(roleAssignmentDetails.status)}
          </Badge>
        </div>

        {/* Remark */}
        <div className="flex gap-x-xs">
          <div className="font-semibold text-brand-primary-darkest w-[120px] sm:w-[250px]">
            Remark:
          </div>
          <div className="font-medium text-neutral-n8 flex-1 break-all">
            {roleAssignmentDetails.remarks ? (
              roleAssignmentDetails.remarks
            ) : (
              <span className="tracking-[1px]">--</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleAssignmentDetailsCard;
